import API from '@services/API';
import { userPermissionsActionTypes } from '@constants/actionTypes/userPermissionsActionTypes';
import { configs } from '@constants/configs/configs';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { Dispatch } from 'redux';

const actions = { setError, startSpinner, stopSpinner };

interface UserPermissionsResponse {
    status: string;
    data: {
        permissions: string[];
    };
}

export const fetchUserPermissionsRequest = () => ({
    type: userPermissionsActionTypes.FETCH_USER_PERMISSIONS_REQUEST,
});

export const fetchUserPermissionsSuccess = (permissions: string[]) => ({
    type: userPermissionsActionTypes.FETCH_USER_PERMISSIONS_SUCCESS,
    permissions,
});

export const fetchUserPermissionsFailure = () => ({
    type: userPermissionsActionTypes.FETCH_USER_PERMISSIONS_FAILURE,
});

export const fetchUserPermissions =
    () => async (dispatch: Dispatch) => {
        dispatch(fetchUserPermissionsRequest());
        const data: UserPermissionsResponse | null = await API.getData(
            configs.endpoints.MEMBER_USER_PERMISSIONS,
            dispatch,
            actions,
            false,
        );
        if (data && data.status === 'SUCCESS' && Array.isArray(data.data?.permissions)) {
            dispatch(fetchUserPermissionsSuccess(data.data.permissions));
        } else {
            dispatch(fetchUserPermissionsFailure());
        }
    };
